import { useEffect, useState } from "react";
import { Row, Col, Container, Dropdown, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../components/Card";
import CustomToggle from "../../components/dropdowns";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

//image
import img1 from "../../assets/images/small/07.png";
import img2 from "../../assets/images/small/08.png";
import img3 from "../../assets/images/small/09.png";
import s5 from "../../assets/images/page-img/s5.jpg";
import img42 from "../../assets/images/page-img/42.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "../../utils/auth";
import { useNavigate } from "react-router-dom";
import { MdOutlineDone } from "react-icons/md";
import moment from "moment";
import PostCard from "./Post/PostCard";
import useAuth from "../../utils/useAuth";
import { useTranslation } from "react-i18next";
import { Country } from "country-state-city";

const Sponsored1 = () => {
  useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [sponsoredAd, setSponsoredAd] = useState([]);
  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const countryCode = response?.data?.data?.country || "";
      const countryInfo = Country.getCountryByCode(countryCode);
      const countryName = countryInfo?.name || "";
      handleSponsored(countryName);

    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  const handleSponsored = async (adsCountry) => {
    try {
        const token = getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/ad/active/ads?country=${adsCountry}`,
          {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        setSponsoredAd(response?.data?.data?.activeHomePageAds);
    } catch (error) {
        console.log("Failed Fetching Sponsored Ads", error);
    }
};


  useEffect(() => {
    fetchUserData();
  }, []);

  if (!sponsoredAd || (Array.isArray(sponsoredAd) && sponsoredAd.length === 0)) {
    return null;
  }

  const handleAdClick = async (adId, websiteLink) => {
    if (!websiteLink) return;

    try {
      const token = getToken();
      await axios.get(`${process.env.REACT_APP_URL}/api/ad/visit/${adId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("Ad visit recorded successfully");
    } catch (error) {
      console.error("Failed to record ad visit:", error);
    }
    window.open(websiteLink, "_blank");
  };

  return (
    <>
   <div id="content-page" className="">
        <div>
          {/* <Row> */}
            <Col lg={12} className="row m-0 p-0">
                <Card
                  id="post-modal-data"
                  className="card-block card-stretch card-height"
                >
                   <div className="stories-data "style={{padding:"10px"}}>
                  <h5 style={{color:"gray"}}>{sponsoredAd?.title} ({t('sponsored')})</h5>
                  <Carousel
                showArrows={false}
                showThumbs={false}
                showStatus={false}
                showIndicators={false}
                infiniteLoop
                autoPlay
                interval={2000}
              >
                {sponsoredAd?.map((image, index) => (
                  <>
                  {sponsoredAd?.websiteLink ? (
                      <div key={index} style={{ cursor: "pointer"}} onClick={() =>
                        handleAdClick(sponsoredAd._id, sponsoredAd.websiteLink)
                      }>
                      <img
                      src={image?.image}
                      className="img-fluid rounded"
                      alt="Sponsored Ad"
                      />
                      </div>
                    ) : (
                      <div key={index}>
                      <img
                        src={image?.image}
                        className="img-fluid rounded"
                        alt="Sponsored Ad"
                      />
                  </div>
                    )}
                    </>
                ))}
              </Carousel>
                </div>
                </Card>
</Col>
{/* </Row> */}
</div>
</div>
    
    </>
  );
};

export default Sponsored1;
